/*
  Takes an address and produces the address that should be entered into IFCS.

  For shipping reasons this address is:
  All the NZ Post Address lines, excluding the final 'TownCity PostCode' line
  which will be generated using those fields in IFCS

*/
export function parseStreetAddress(address: any, postal: boolean = false) {
  if (address) {
    const {
      addressLine1,
      addressLine2,
      addressLine3,
      addressLine4,
      addressLine5,
      postcode,
      cityTown,
    } = address;

    // This is the set of address lines expected to be printed
    const addressLines = [addressLine1, addressLine2, addressLine3, addressLine4, addressLine5];

    // The last address line is included in the ifcs info, so we treat it specially to avoid duplication
    const finalLine = `${cityTown} ${postcode}`;

    // Add all the lines except for the last line togetherz
    let fullAddress = "";
    for (const addressLine of addressLines) {
      if (addressLine !== finalLine && addressLine != null) {
        fullAddress += `${addressLine}, `;
      }
    }

    // This will leave a trailing ',' but remove the space.
    // Seems counter intiutive but matches the requirments for letter printing.
    return fullAddress.trim();
  }
  return "";
}
